import { call, put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import { logOut } from '../login/action';
import * as QueryParams from 'query-string';
import { callApi, callApiWithNoAuth, Method, request } from '../../api/Api';
import { getConfig } from '../../services/environment';
import { stopLoading, showErrorMessage, startLoading } from '../layout/action';
import { GET_DRIVER_PERMITLIST_STATES, GET_DRIVER_PERMIT_RESION, setDriverPermitListStates, setDriverPermitListStatesError, setDriverPermitResionText } from './action';


export function* callGetDriverPermitListStates(action) {
  try {
    //  const { loginState } = yield select();
    //  const { userContext } = loginState;

    yield put(startLoading())

    const dataLocation = window.location.href
    let url = String(dataLocation)
    let getGroupname = (url) => {
      let f = url.split("/")
      let dats
      for (let i = 2; i < f.length; i++) {
        if (f[i] == "driverportal") {
          dats = f[i + 1]
        }
      }
      return dats
    }

    let datas = {
      accountId:action.payload,
      clientUserName : getGroupname(url)
    }
     const stateResponse = yield call(callApi, {

      // data: QueryParams.stringify(datas),
      data: datas,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      url: `/orders/purchasable-permits/driver`
   })
     
     const { data } = stateResponse;
     yield put(setDriverPermitListStatesError([]))
     yield put(setDriverPermitListStates(data))
     yield put(stopLoading())
  } catch (err) {
    yield put(stopLoading())
    let error = err?.data?.errorMessages;
    yield put(setDriverPermitListStates([]))
    yield put(setDriverPermitListStatesError(error))
      // yield put(showErrorMessage({ error: err, title: "Deny virtual Permit List" }))
  }
}

export function* watchGetDriverPermitListStates() {
  yield takeEvery(GET_DRIVER_PERMITLIST_STATES, callGetDriverPermitListStates);
}



export function* callGetDriverVirtualPermitResionText(action) {
  try {
    //  const { loginState } = yield select();
    //  const { userContext } = loginState;
     yield put(startLoading())
     const stateResponse = yield call(callApiWithNoAuth, {
        method: "GET",
        // url: `/permit-types/efp/options/${action.payload}`
        url: `/portal/pages/home-without-session/permit-types/efp/options/${action.payload}`
     })
     
     const { data } = stateResponse;
     yield put(setDriverPermitResionText(data))
     yield put(stopLoading())
  } catch (err) {
     yield put(stopLoading())
     yield put(showErrorMessage({ error: err, title: "Get Permit Reason" }))
  }
}

export function* watchGetDriverVirtualPermitResion() {
  yield takeEvery(GET_DRIVER_PERMIT_RESION, callGetDriverVirtualPermitResionText);
}